import isEmpty from "is-empty";

export default class ChatRoomClass {

    // properties
    documentId = "";
    userIds = null;
    createdAt = null;
    lastMessageAt = null;
    lastMessage = "";
    lastMessageType = -1;
    lastMessageUserId = "";
    lastMessageAttachment = null;
    lastMessageIsRead = false;
    disabled = false;

    constructor() { }

    // setters
    setCreatedAt(createdAt) {
        this.createdAt = createdAt;
    }

    setLastMessageAt(lastMessageAt) {
        this.lastMessageAt = lastMessageAt;
    }

    setLastMessageType(lastMessageType) {
        this.lastMessageType = lastMessageType;
    }

    setLastMessage(lastMessage) {
        this.lastMessage = lastMessage;
    }

    setLastMessageUserId(lastMessageUserId) {
        this.lastMessageUserId = lastMessageUserId;
    }

    setUserIds(userIds) {
        this.userIds = userIds;
    }

    setDocumentId(documentId) {
        this.documentId = documentId;
    }

    setLastMessageIsRead(isRead) {
        this.lastMessageIsRead = isRead;
    }

    setDisabled(isDisabled) {
        this.disabled = isDisabled;
    }

    setLastMessageAttachment(lastMessageAttachment) {
        this.lastMessageAttachment = lastMessageAttachment;
    }

    toObject() {
        const obj = {};
        obj.userIds = this.userIds;
        obj.createdAt = this.createdAt;
        obj.lastMessageAt = this.lastMessageAt;
        obj.lastMessage = this.lastMessage;
        obj.lastMessageType = this.lastMessageType;
        obj.lastMessageUserId = this.lastMessageUserId
        obj.lastMessageIsRead = this.lastMessageIsRead;
        obj.disabled = this.disabled;

        if (!isEmpty(this.lastMessageAttachment)) {
            obj.lastMessageAttachment = this.lastMessageAttachment;
        }

        return obj;
    }
}